<template>
  <b-modal v-bind:id="id"
           class="basic-modal policy-modal hide-cancel-btn"
           v-bind:title="title"
           v-bind:ok-title="$t('common.close')"
           v-on:shown="onOpen">
    <div class="policy-container scroll-box">
      <VueMarkdown v-if="markdown" v-bind:source="markdown"></VueMarkdown>
    </div>
  </b-modal>
</template>

<script>
  import VueMarkdown from 'vue-markdown';
  import { mapActions } from 'vuex';

  import { POLICY_VERSIONS, CLASSTING_URL } from '@/config';

  export default {
    name: 'policy-modal',

    props: [
      'id',
      'title',
      'policyId',
    ],

    components: {
      VueMarkdown,
    },

    data() {
      return {
        markdown: null,

        policyVersion: null,

        lang: 'ko',
      };
    },

    methods: {
      ...mapActions([
        'fetchPolicy',
      ]),

      onOpen() {
        if (!this.markdown) {
          this.policyVersion = POLICY_VERSIONS[this.policyId][this.lang][0];

          this.fetchPolicy(this.policyVersion.url)
            .then((md) => {
              this.markdown = md.replace('/policies/', `${CLASSTING_URL}/policies/`);
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/PolicyModal.vue